import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { FinancialEntityNameFailure, FinancialEntityNameRequest, FinancialEntityNameSuccess } from './actions';
import { FinancialEntityNameService } from './service';

@Injectable()
export class FinancialEntityNameEffects {
  private readonly actions$ = inject(Actions);
  private readonly financialEntityNameService = inject(FinancialEntityNameService);

  financialEntityName$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FinancialEntityNameRequest),
      switchMap(({ parameters }) =>
        this.financialEntityNameService.financialEntityName(parameters).pipe(
          map(data => FinancialEntityNameSuccess({ data })),
          catchError(error => of(FinancialEntityNameFailure({ error })))
        )
      )
    )
  );

}
